<template>
  <div>
         <el-row>
            <el-col>
              <el-upload
                             class="avatar-uploader"
                             action="aa"
                             :show-file-list="false"
                             :on-success="handleSuccess"
                             :before-upload="handleBeforeUpload"
                             :on-change="uploadImg">
                  <span v-if="voucherItemObject.url!=null && voucherItemObject.fileType=='image'">
                    <img v-if="voucherItemObject.url" :src="voucherItemObject.url" class="avatar">
                  </span>
                  <span v-else-if="voucherItemObject.url!=null && voucherItemObject.fileType=='video'">
                    <video autoplay loop style="width:178px; height: 178px" :src="voucherItemObject.url" />
                  </span>
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </el-col>
         </el-row>
         <el-row>
          <el-col>
            <el-radio v-model="voucherItemObject.fileType" label="image">图片</el-radio>
            <el-radio v-model="voucherItemObject.fileType" label="video">视频</el-radio>
            <el-button  style="margin-left:5px"  icon="el-icon-delete"  @click="deleteVoucherItem()"></el-button>
          </el-col>
         </el-row>
  </div>
</template>

<script>
export default {
  name: "voucherItem",
  components: {},
  props: [
    "voucherItemObject",
    "itemIndex",
  ],
  data() {
    return {

    };
  },
  watch: {
  },
  computed: {},
  methods: {
    deleteVoucherItem(){
       this.$emit(
        "deleteVoucherItem",
        this.$props.itemIndex
      );
    },
    handleSuccess(res, file) {
          console.log(res)
          console.log(file)
      },
      handleBeforeUpload(file) {
          console.log(file);
          let formData = new FormData()
          formData.append("multipartFile", file);
          this.$api.uploadImageFull(formData).then(res => {
              console.log(res);
              this.voucherItemObject.url = res.data;
          });
          return false;
      },
      uploadImg() {

      }

  },
  created() {},
  mounted() {
  },
};
</script>
<style lang="less" scoped>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>
